import { render } from "./CarouselDay.vue?vue&type=template&id=60358ebc&scoped=true"
import script from "./CarouselDay.vue?vue&type=script&lang=js"
export * from "./CarouselDay.vue?vue&type=script&lang=js"

import "./CarouselDay.vue?vue&type=style&index=0&id=60358ebc&scoped=true&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60358ebc"]])

export default __exports__